import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import BackToTop from '../components/layout/BackToTop';
import HeroSection from '../components/sections/HeroSection';
import ProblemBridge from '../components/sections/ProblemBridge';
import JourneySection from '../components/sections/JourneySection';
import DifferentiatorsSection from '../components/sections/DifferentiatorsSection';
import PilotInviteSection from '../components/sections/PilotInviteSection';

const LandingPage = () => {
  React.useEffect(() => {
    if (window.location.hash) {
      setTimeout(() => {
        document.querySelector(window.location.hash)?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFAF8]">
      <Header />
      <main>
        {/* 1. Simplified hero */}
        <HeroSection />

        {/* 2. Compact problem/continuity bridge */}
        <ProblemBridge />

        {/* 3. Four-step ResiAX journey */}
        <JourneySection />

        {/* 4. Three differentiators */}
        <DifferentiatorsSection />

        {/* 5. Final resident CTA + small provider route */}
        <PilotInviteSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default LandingPage;
